// @flow

import { combineReducers } from 'redux'
import { DataGridDuck, formActions, createFormReducer, createDataGridReducer } from 'react-redux-components'
import authenticatedRequest from './authenticated-request'
import { addSuccessNotification, addErrorNotification } from './notification-manager'

import type { DataGridState, FormState } from 'react-redux-components'
import type { GetState, Dispatch, ReduxAction } from './index'
import type { NetError } from './authenticated-request'

export const UPDATE_DOCTOR_PENDING: 'panel/UPDATE_DOCTOR_PENDING' = 'panel/UPDATE_DOCTOR_PENDING'
export const UPDATE_DOCTOR_SUCCESS: 'panel/UPDATE_DOCTOR_SUCCESS' = 'panel/UPDATE_DOCTOR_SUCCESS'
export const UPDATE_DOCTOR_ERROR: 'panel/UPDATE_DOCTOR_ERROR' = 'panel/UPDATE_DOCTOR_ERROR'

export const DELETE_DOCTOR_REQUEST: 'panel/DELETE_DOCTOR_REQUEST' = 'panel/DELETE_DOCTOR_REQUEST'
export const DELETE_DOCTOR_CANCEL: 'panel/DELETE_DOCTOR_CANCEL' = 'panel/DELETE_DOCTOR_CANCEL'

export const DELETE_DOCTOR_PENDING: 'panel/DELETE_DOCTOR_PENDING' = 'panel/DELETE_DOCTOR_PENDING'
export const DELETE_DOCTOR_SUCCESS: 'panel/DELETE_DOCTOR_SUCCESS' = 'panel/DELETE_DOCTOR_SUCCESS'
export const DELETE_DOCTOR_ERROR: 'panel/DELETE_DOCTOR_ERROR' = 'panel/DELETE_DOCTOR_ERROR'

export type ACTION_UPDATE_DOCTOR_PENDING = {| type: typeof UPDATE_DOCTOR_PENDING |}
export type ACTION_UPDATE_DOCTOR_SUCCESS = {| type: typeof UPDATE_DOCTOR_SUCCESS |}
export type ACTION_UPDATE_DOCTOR_ERROR = {| type: typeof UPDATE_DOCTOR_ERROR, payload: NetError |}

export type Doctor = {
  _id: string,
  nome: string,
  cognome: string,
}

type ACTION_DELETE_DOCTOR_REQUEST = {| type: typeof DELETE_DOCTOR_REQUEST, payload: Doctor |}
type ACTION_DELETE_DOCTOR_CANCEL = {| type: typeof DELETE_DOCTOR_CANCEL |}

type ACTION_DELETE_DOCTOR_PENDING = {| type: typeof DELETE_DOCTOR_PENDING |}
type ACTION_DELETE_DOCTOR_SUCCESS = {| type: typeof DELETE_DOCTOR_SUCCESS |}
type ACTION_DELETE_DOCTOR_ERROR = {| type: typeof DELETE_DOCTOR_ERROR, payload: NetError |}

export type ManagePanelAction =
  | ACTION_UPDATE_DOCTOR_PENDING
  | ACTION_UPDATE_DOCTOR_SUCCESS
  | ACTION_UPDATE_DOCTOR_ERROR
  | ACTION_DELETE_DOCTOR_REQUEST
  | ACTION_DELETE_DOCTOR_CANCEL
  | ACTION_DELETE_DOCTOR_PENDING
  | ACTION_DELETE_DOCTOR_SUCCESS
  | ACTION_DELETE_DOCTOR_ERROR

type Status = 'NEW' | 'PENDING' | 'SUCCESS' | 'ERROR'
export const statuses = {
  NEW: 'NEW',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

type PanelState_ = {|
  status: Status,
  deleteDoctorPending: Doctor | false,
|}
type PanelState = $Shape<PanelState_>

// Initial state
export const initialState: PanelState = {
  status: statuses.NEW,
  deleteDoctorPending: false,
}

// Reducer
export const reducer = (state: PanelState = initialState, action: ReduxAction): PanelState => {
  switch (action.type) {
    case UPDATE_DOCTOR_PENDING:
    case DELETE_DOCTOR_PENDING:
      return { ...state, status: statuses.PENDING }
    case UPDATE_DOCTOR_SUCCESS:
    case DELETE_DOCTOR_SUCCESS:
      return { ...state, status: statuses.SUCCESS }
    case UPDATE_DOCTOR_ERROR:
    case DELETE_DOCTOR_ERROR:
      return { ...state, status: statuses.ERROR }

    case DELETE_DOCTOR_REQUEST:
      return { ...state, deleteDoctorPending: action.payload }
    case DELETE_DOCTOR_CANCEL:
      return { ...state, deleteDoctorPending: false }

    default:
      return state
  }
}

export type ManagePanelState = {
  grid: DataGridState,
  form: FormState,
  status: PanelState,
}
export default combineReducers({
  grid: createDataGridReducer('panelGrid'),
  form: createFormReducer('panel.form', {}),
  status: reducer,
})

export const onModifyRecord = (record: Doctor) => {
  return (dispatch: Dispatch, getState: GetState) => {
    dispatch(formActions.load('panel.form', record))
    dispatch(DataGridDuck.creators.openSidebar('panelGrid'))
  }
}

export const cancelEdit = () => {
  return (dispatch: Dispatch, getState: GetState) => {
    dispatch(formActions.reset('panel.form'))
    dispatch(DataGridDuck.creators.closeSidebar('panelGrid'))
  }
}

export const updateDoctor = (campaignName: string, doctor: Doctor) => async (
  dispatch: Dispatch,
  getState: GetState
) => {
  dispatch({ type: UPDATE_DOCTOR_PENDING })
  try {
    let response = await authenticatedRequest.put(
      '/api/panels/' + encodeURIComponent(campaignName) + '/doctors/' + doctor._id + '/update',
      doctor
    )
    dispatch({ type: UPDATE_DOCTOR_SUCCESS })
    dispatch(DataGridDuck.creators.closeSidebar('panelGrid'))
    dispatch(addSuccessNotification(response.data.message))
    dispatch(DataGridDuck.creators.getRecords('panelGrid', {}, authenticatedRequest))
    dispatch(formActions.reset('panel.form'))
  } catch (err) {
    dispatch({ type: UPDATE_DOCTOR_ERROR, payload: err })
    dispatch(formActions.setPending('panel.form', false))
    dispatch(addErrorNotification(err.response.data.message))
  }
}

export const deleteDoctorRequest = (doctor: Doctor): ACTION_DELETE_DOCTOR_REQUEST => ({
  type: DELETE_DOCTOR_REQUEST,
  payload: doctor,
})
export const deleteDoctorCancel = (): ACTION_DELETE_DOCTOR_CANCEL => ({ type: DELETE_DOCTOR_CANCEL })
export const deleteDoctor = (campaignName: string, doctor: Doctor) => async (
  dispatch: Dispatch,
  getState: GetState
) => {
  dispatch({ type: DELETE_DOCTOR_PENDING })
  try {
    let response = await authenticatedRequest.delete(
      '/api/panels/' + encodeURIComponent(campaignName) + '/doctors/' + doctor._id + '/delete'
    )
    dispatch({ type: DELETE_DOCTOR_SUCCESS })
    dispatch(addSuccessNotification(response.data.message))
    dispatch(DataGridDuck.creators.getRecords('panelGrid', {}, authenticatedRequest))
  } catch (err) {
    dispatch({ type: DELETE_DOCTOR_ERROR, payload: err })
    dispatch(addErrorNotification(err.response.data.message))
  }
  dispatch(deleteDoctorCancel())
}



// WEBPACK FOOTER //
// ./src/store/manage-panel.js